import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ExclamationTriangleSmallIcon from '@hapana/shared/web/styles/assets/svgs/exclamation-triangle-small.svg'
import AlertDialog from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.component'
import {
  SIZES,
  VARIANTS,
} from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { useCancelEquipmentAssignment } from '_hooks/equipment-assignments.hooks'
import { EQUIPMENT_STATUSES } from '_constants/equipments'

export const StopTimerDialog = ({
  assignmentId,
  equipmentId,
  equipmentName,
  siteId,
  equipmentStatus,
  isLiveVersion,
}) => {
  const { t } = useTranslation('checkIn')
  const { popDialog, setDialogState } = useDialog()
  const { mutate: cancelAssignment, isLoading } = useCancelEquipmentAssignment({
    siteId,
    equipmentId,
    onSuccess: () => {
      setDialogState({ defaultTab: '3' })
      popDialog()
    },
  })

  const handleStopTimer = () => {
    cancelAssignment({ assignmentId })
  }

  // Determine the description based on status and live version
  let description = t('checkIn:equipments.stopTimerDialog.description', {
    equipmentName,
  })

  if (isLiveVersion) {
    if (equipmentStatus === EQUIPMENT_STATUSES.IN_USE) {
      description = t('checkIn:equipments.stopTimerDialog.descriptionInUseLive', {
        equipmentName,
      })
    } else if (equipmentStatus === EQUIPMENT_STATUSES.DELAY) {
      description = t('checkIn:equipments.stopTimerDialog.descriptionDelayLive', {
        equipmentName,
      })
    }
  }

  return (
    <AlertDialog
      title={t('checkIn:equipments.stopTimerDialog.title')}
      description={description}
      icon={ExclamationTriangleSmallIcon}
      size={SIZES.XS}
      variant={VARIANTS.NEUTRAL}
      closeAction={popDialog}
      primaryAction={{
        label: t('checkIn:equipments.stopTimerDialog.okay'),
        action: handleStopTimer,
        props: {
          isLoading,
        },
      }}
      secondaryAction={{
        label: t('common:cancel'),
        action: popDialog,
      }}
    />
  )
}

StopTimerDialog.propTypes = {
  assignmentId: PropTypes.string.isRequired,
  equipmentId: PropTypes.string.isRequired,
  equipmentName: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  equipmentStatus: PropTypes.string,
  isLiveVersion: PropTypes.bool,
}

export default StopTimerDialog
